import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  Wallet,

  LogOut,
  Shield,

  TrendingUp,

  Coins,
  Download,
  DollarSign,
  Building,
  QrCode,
} from 'lucide-react';
import { useAuthStore } from '@/store/authStore';
import clsx from 'clsx';

const Sidebar: React.FC = () => {
  const { user, logout } = useAuthStore();
  const location = useLocation();

  const menuItems = [
    {
      section: 'Overview',
      items: [
        {
          label: 'Dashboard',
          icon: LayoutDashboard,
          path: '/dashboard',
        },
         {
          label: 'Users',
          icon: Users,
          path: '/users',
          badge: 'Live',
        },
        {
          label: 'Wallets',
          icon: Wallet,
          path: '/wallets',
        },
      ],
    },

  
    {
      section: 'Gaming',
      items: [
       
        {
          label: 'Live Games',
          icon: TrendingUp,
          path: '/games/live',
          badge: 'Live',
        },
      ],
    },
    {
      section: 'Coin System',
      items: [
        {
          label: 'Purchase Approvals',
          icon: Coins,
          path: '/coins/purchases',
          badge: 'Hot',
        },
        {
          label: 'Withdrawal Approvals',
          icon: Download,
          path: '/coins/withdrawals',
          badge: 'Hot',
        },
        {
          label: 'Offer Management',
          icon: DollarSign,
          path: '/coins/offers',
        },
        {
          label: 'Bank Accounts',
          icon: Building,
          path: '/coins/bank-accounts',
        },
        {
          label: 'UPI Accounts',
          icon: QrCode,
          path: '/coins/upi-accounts',
        },
      ],
    },
    
  ];

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="w-64 bg-white text-slate-900 h-full flex flex-col shadow-xl border-r border-slate-200">
      {/* Header */}
      <div className="p-6 border-b border-slate-200">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg flex items-center justify-center shadow-md">
            <Shield className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-slate-900">InCoinX</h1>
            <p className="text-xs text-slate-500 font-medium">Admin Panel</p>
          </div>
        </div>
      </div>

      {/* User Info */}
      <div className="p-4 border-b border-slate-200 bg-slate-50/50">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-white border border-slate-200 rounded-full flex items-center justify-center shadow-sm">
            <span className="text-sm font-bold text-purple-600">
              {user?.username?.charAt(0).toUpperCase() || 'A'}
            </span>
          </div>
          <div className="flex-1">
            <p className="text-sm font-semibold text-slate-900">{user?.username || 'Admin'}</p>
            <p className="text-xs text-slate-500 capitalize">{user?.role || 'Admin'}</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto p-4 scrollbar-thin scrollbar-thumb-slate-200 hover:scrollbar-thumb-slate-300">
        <div className="space-y-6">
          {menuItems.map((section) => (
            <div key={section.section}>
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3 px-3">
                {section.section}
              </h3>
              <div className="space-y-1">
                {section.items.map((item) => {
                  const isActive = location.pathname === item.path || 
                    (item.path !== '/dashboard' && location.pathname.startsWith(item.path));
                  
                  return (
                    <NavLink
                      key={item.path}
                      to={item.path}
                      className={clsx(
                        'flex items-center justify-between px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200',
                        isActive
                          ? 'bg-purple-50 text-purple-700 shadow-sm ring-1 ring-purple-100'
                          : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
                      )}
                    >
                      <div className="flex items-center space-x-3">
                        <item.icon className={clsx("w-5 h-5", isActive ? "text-purple-600" : "text-slate-400 group-hover:text-slate-600")} />
                        <span>{item.label}</span>
                      </div>
                      {item.badge && (
                        <span
                          className={clsx(
                            'px-2 py-0.5 text-[10px] rounded-full font-bold uppercase tracking-wide',
                            item.badge === 'Live'
                              ? 'bg-green-100 text-green-700 border border-green-200'
                              : item.badge === 'Hot'
                              ? 'bg-red-100 text-red-700 border border-red-200'
                              : 'bg-blue-100 text-blue-700 border border-blue-200'
                          )}
                        >
                          {item.badge}
                        </span>
                      )}
                    </NavLink>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-slate-200 bg-slate-50/50">
        <button
          onClick={handleLogout}
          className="w-full flex items-center space-x-3 px-3 py-2.5 rounded-lg text-sm font-medium text-slate-600 hover:bg-red-50 hover:text-red-600 transition-colors duration-200 group"
        >
          <LogOut className="w-5 h-5 text-slate-400 group-hover:text-red-500" />
          <span>Sign Out</span>
        </button>
        
        <div className="mt-4 text-center">
          <p className="text-[10px] text-slate-400 font-medium">
            © 2024 InCoinX Admin
          </p>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;